import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function Engine() {
  const face = FACE_BY_ID.engine;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Motores"
      titulo="Unity e Unreal, do protótipo até a loja."
      intro="Programação de jogo, renderização, rede e as ferramentas de editor que fazem o resto do time conseguir trabalhar. Dez anos entre celular, PC e realidade virtual."
      entrego={[
        {
          titulo: "Programação de jogo",
          corpo: "Máquinas de estado, arquitetura orientada a dados onde ela se paga, e código preparado para rodar em rede.",
        },
        {
          titulo: "Renderização que roda no celular",
          corpo: "Shaders e iluminação dentro do orçamento de um aparelho comum, não só da sua máquina de desenvolvimento.",
        },
        {
          titulo: "Ferramenta de editor",
          corpo: "Extensões de Unity para quem não programa publicar conteúdo sem passar por um programador.",
        },
      ]}
      publicado={[
        {
          titulo: "Magic: Puzzle Quest",
          marca: "Unity · 2019",
          corpo: "Combinar peças com RPG na marca Magic: The Gathering, da Wizards of the Coast. Desenvolvedor na Oktagon Games, publicado pela D3 Publisher, iOS e Android.",
          link: "https://play.google.com/store/apps/details?id=com.d3p.olympic",
        },
        {
          titulo: "Doodle Jump Adventure",
          marca: "Unity · 2019",
          corpo: "Jogo de pulo da franquia da Lima Sky. Saiu das lojas oficiais e segue listado no QooApp.",
          link: "https://m-apps.qoo-app.com/en-US/app/10205",
        },
      ]}
    />
  );
}
